import React from 'react';

const institutions = ['MIT', 'Stanford', 'Harvard', 'Yale', 'UCLA', 'Oxford', 'NIH'];

const ResearchInstitutionsBar: React.FC = () => {
    return (
        <section
            className="w-full bg-black py-20 md:py-24"
            aria-label="Research institutions"
        >
            {/* Label */}
            <p className="text-center text-base md:text-lg font-light text-white/70 tracking-[0.2em] uppercase mb-10 md:mb-14">
                Built on research from
            </p>

            {/* Infinite Scroll Container */}
            <div className="relative w-full overflow-hidden">
                {/* Fade edges */}
                <div className="absolute left-0 top-0 bottom-0 w-24 md:w-64 bg-gradient-to-r from-black via-black/80 to-transparent z-10 pointer-events-none" />
                <div className="absolute right-0 top-0 bottom-0 w-24 md:w-64 bg-gradient-to-l from-black via-black/80 to-transparent z-10 pointer-events-none" />

                {/* Single marquee track with duplicate for seamless loop */}
                <div className="marquee-container inline-flex whitespace-nowrap">
                    {/* Render twice for continuous effect */}
                    {[...institutions, ...institutions].map((name, index) => (
                        <span
                            key={index}
                            className="mx-10 md:mx-16 text-3xl md:text-5xl font-bold text-white/80 tracking-widest uppercase"
                        >
                            {name}
                        </span>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ResearchInstitutionsBar;
